import React from "react"
import PropTypes from "prop-types"

const WishedCarFreetext = ({ strings, wishFreetextChange }) => {
  return (
    <div className="wished-car-freetext form-row">
      <label htmlFor="wished-car-freetext-textarea">{strings.additionalInfoInputHeading}</label>
      <textarea
        id="wished-car-freetext-textarea"
        className="full-width"
        onChange={(e) => wishFreetextChange(e)}
        placeholder={strings.additionalInfoInputDescription}
        autoComplete="off"
      />
    </div>
  )
}

WishedCarFreetext.propTypes = {
  strings: PropTypes.object,
  wishFreetextChange: PropTypes.func,
}

export default WishedCarFreetext
